<template>
    <section class="contestant-section-wrapper">
        <div class="w-100" :class="{ 'row mx-0 justify-content-between' : isDesktop}">
            <MediaGallery :key="'gallery-' + activePage" id="mediaGalleryWrapper" ref="mediaGalleryWrapper"/>
            <SubmissionSetup :key="'submission-' + activePage"/>
        </div>
        <ParticipationInfo
            v-if="activePage == 'voting'"
            :title="pastimeInfo.baseInfo.name "
            :description="pastimeDescription"
            :button-text="mainButtonText"
            :enabled="enableRegistration || enableGoToSubmission"
            :action-type="'link'"
            :secondary-button-text="!isDesktop ? kStrings.kVIEW_PASTIME : ''"
            :secondary-action-type="'secondary-link'"
            :participation-warning="cantRegisterMotive"
            :class="{ 'mt-4' : isDesktop }"
            @link="!hasRegistered ? loadRegistration() : goToLink(customerSubmissonDetails.shareUrl)"
            @secondary-link="goToLink(urls.pastimeUrl)"
        />
    </section>
</template>

<script>

import MediaGallery from '@/components/Pastimes/Desktop/sections/MediaGallery';
import SubmissionSetup from '@/components/Pastimes/Desktop/sections/SubmissionSetup';
import ParticipationInfo from '@/components/Pastimes/Desktop/partials/ParticipationInfo';
import {isEmpty} from 'lodash-es';
//import homeUtils from '@/Utilities/homeUtils';

export default {
    name: 'ContestantSection',
    components: {
        MediaGallery,
        SubmissionSetup,
        ParticipationInfo
    },
    props: {
        //prop1: {type: Object, default: null, required: false}
    },
    data() {
        return {
           // data1: null
        }
    },
    computed: {
        isLogged() {
            return this.$store.getters.isLogged;
        },
        isDesktop() {
            return this.$store.getters.isDesktop;
        },
        activePage() {
            return this.$store.getters.activePage;
        },
        kStrings() {
            return this.$store.getters.kStrings;
        },
        urls() {
            return this.$store.getters.urls;
        },
        pastimeInfo() {
            return this.$store.getters.pastimeInfo;
        },
        fromCustomer() {
            let registrationInfo = this.$store.getters['contestantPage/registrationInfo'];
            if(isEmpty(registrationInfo)) {
                return false;
            }
            return registrationInfo.fromCustomer;
        },
        hasEnded() {
            return this.pastimeInfo.detailedInfo.hasEnded;
        },
        registerValidation(){
            return this.$store.getters.registerValidation;
        },
        enableRegistration() {
            if(this.fromCustomer) {
                return false;
            }
            if(this.submissionIsPending){
                return false;
            }
            let canRegister = this.registerValidation.canRegister;
            return canRegister && !this.hasEnded && !this.hasRegistered;
        },
        customerSubmissonDetails() {
            return !isEmpty(this.$store.getters.customerRegistrationInfo) ? this.$store.getters.customerRegistrationInfo : null;
        },
        submissionIsPending(){
            return this.customerSubmissonDetails?.isPending ?? false;
        },
        enableGoToSubmission() {
            if(!this.isLogged && !this.hasEnded) {
                return true;
            }
            
            if(this.fromCustomer) {
                return false;
            }
            
            if(!this.customerSubmissonDetails || !this.customerSubmissonDetails.isApproved) {
                return false;
            }

            return this.customerSubmissonDetails.isApproved;
        },
        submissionInApprovalState() {
            if(!this.customerSubmissonDetails) {
                return null
            }
            
            if(this.submissionIsPending) {
                return this.warningStruct(this.kStrings.kPASTIME_REGISTRATION_NOT_VALIDATED,this.kStrings.kINSCRIPTION_IN_VALIDATION);
            }
            
            return null;

        },
        cantRegisterMotive() {
            if(this.enableRegistration) {
                return null;
            }
            if(!this.isLogged){
                return null;
            }

            if(this.fromCustomer) {
                return null;
            }
            let isPending = this.submissionInApprovalState;
            if(isPending){
                return isPending;
            }

            let motive = this.registerValidation?.motive ?? this.kStrings.kCANT_REGISTER_PASTIME_FOR_NOW;
            return this.warningStruct(null,motive);
        },
        hasRegistered() {
            return this.pastimeInfo.detailedInfo.hasRegistered;
        },
        mainButtonText() {
            if(!this.isLogged && !this.hasEnded) {
                return this.kStrings.kPARTICIPATE;
            }
            
            if(this.submissionIsPending) {
                return this.kStrings.kREGISTRATION_SUBMITTED;
            }

            if(this.hasRegistered) {
                return this.kStrings.kGO_TO_REGISTRATION;
            }

            return this.kStrings.kPARTICIPATE;
        },
        pastimeDescription() {
            return !this.hasEnded ? this.$store.getters.pastimeDescriptionContent : this.kStrings.kGIVEAWAY_STATUS_ENDED;
        }
    },
    watch: {},
    created() {
    },
    mounted() {
        this.$nextTick(() => {
            if(this.isDesktop) {
                window.removeEventListener("resize", this.setMaxContentHeight);
                window.addEventListener("resize", this.setMaxContentHeight);
                setTimeout(() => {
                    this.setMaxContentHeight();
                }, 150);
            }
        });
    },
    methods: {
        warningStruct(pop,msg){
            return {
                popupMsg: pop,
                warningMsg:  msg
            }
        },
        loadRegistration() {
            if(this.isLogged) {
                this.$emit('load-registration');
            } else {
                if(this.isDesktop) {
                    accountAuth.openLogin();
                } else {
                    window.location.replace(this.urls.login);
                }
            }
        },
        setMaxContentHeight() {
            let mediaGalleryWrapper = this.$refs.mediaGalleryWrapper.$el;
            if(!mediaGalleryWrapper) {
                mediaGalleryWrapper = document.getElementById('mediaGalleryWrapper');
            }
            let mediaGalleryWrapperHeight = mediaGalleryWrapper.offsetHeight;
            if(mediaGalleryWrapperHeight) {
                let submissionSetupWrapper = document.getElementById('submissionSetupWrapper');
                submissionSetupWrapper.style.maxHeight = mediaGalleryWrapperHeight + 'px';
            }
        },
        goToLink(link) {
            if(link) {
                window.location.assign(link);
            }
        }
    }
};
</script>

<style scoped>

</style>